const initialState = {
  emailDisclosureRequesting: false,
  emailDisclosureSuccessful: false,
  emailDisclosureError: null,
};

export default function feed(state = initialState, action) {
  switch (action.type) {
    case "EMAIL_DISCLOSURE_REQUESTED":
      return {
        ...state,
        emailDisclosureRequesting: true,
      };
    case "EMAIL_DISCLOSURE_SUCCESS":
      return {
        ...state,
        emailDisclosureRequesting: false,
        emailDisclosureSuccessful: true,
        emailDisclosureError: null,
      };
    case "EMAIL_DISCLOSURE_FAIL":
      return {
        ...state,
        emailDisclosureRequesting: false,
        emailDisclosureSuccessful: false,
        emailDisclosureError: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/disclosure.reducer.js